var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("courseware-default-container", {
    attrs: {
      container: _vm.container,
      containerClass: "cw-container-list",
      canEdit: _vm.canEdit,
      isTeacher: _vm.isTeacher,
    },
    on: {
      storeContainer: _vm.storeContainer,
    },
    scopedSlots: _vm._u([
      {
        key: "containerContent",
        fn: function fn() {
          return [
            !_vm.showEditMode || _vm.currentElementisLink
              ? _c(
                  "ul",
                  {
                    staticClass: "cw-container-list-block-list",
                  },
                  _vm._l(_vm.blocks, function (block) {
                    return _c(
                      "li",
                      {
                        key: block.id,
                        staticClass: "cw-block-item",
                      },
                      [
                        _c(_vm.component(block), {
                          tag: "component",
                          attrs: {
                            block: block,
                            canEdit: _vm.canEdit,
                            isTeacher: _vm.isTeacher,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              : [
                  !_vm.processing
                    ? [
                        _c(
                          "span",
                          {
                            staticClass: "assistive-text",
                            attrs: {
                              "aria-live": "assertive",
                            },
                          },
                          [_vm._v(_vm._s(_vm.assistiveLive))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "assistive-text",
                            attrs: {
                              id: "operation",
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$gettext(
                                    "Drücken Sie die Leertaste, um neu anzuordnen."
                                  )
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showEditMode && _vm.canEdit
                          ? _c(
                              "draggable",
                              _vm._b(
                                {
                                  ref: "sortables",
                                  staticClass:
                                    "cw-container-list-block-list cw-container-list-sort-mode",
                                  attrs: {
                                    tag: "ol",
                                    role: "listbox",
                                    handle: ".cw-sortable-handle",
                                    group: "blocks",
                                    containerId: _vm.container.id,
                                    sectionId: "0",
                                  },
                                  on: {
                                    start: function start($event) {
                                      _vm.isDragging = true
                                    },
                                    end: _vm.dropBlock,
                                  },
                                  model: {
                                    value: _vm.blockList,
                                    callback: function callback($$v) {
                                      _vm.blockList = $$v
                                    },
                                    expression: "blockList",
                                  },
                                },
                                "draggable",
                                _vm.dragOptions,
                                false
                              ),
                              _vm._l(_vm.blockList, function (block) {
                                return _c(
                                  "li",
                                  {
                                    key: block.id,
                                    staticClass:
                                      "cw-block-item cw-block-item-sortable",
                                  },
                                  [
                                    _c("span", {
                                      ref: "sortableHandle" + block.id,
                                      refInFor: true,
                                      staticClass: "cw-sortable-handle",
                                      class: {
                                        "cw-sortable-handle-dragging":
                                          _vm.isDragging,
                                      },
                                      attrs: {
                                        tabindex: "0",
                                        role: "button",
                                        "aria-describedby": "operation",
                                      },
                                      on: {
                                        keydown: function keydown($event) {
                                          return _vm.keyHandler(
                                            $event,
                                            block.id
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(_vm.component(block), {
                                      tag: "component",
                                      class: {
                                        "cw-block-item-selected":
                                          _vm.keyboardSelected === block.id,
                                      },
                                      attrs: {
                                        block: block,
                                        canEdit: _vm.canEdit,
                                        isTeacher: _vm.isTeacher,
                                        blockId: block.id,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("courseware-block-adder-area", {
                          attrs: {
                            container: _vm.container,
                            section: 0,
                          },
                        }),
                      ]
                    : _c(
                        "div",
                        {
                          staticClass: "progress-wrapper",
                          style: {
                            height: _vm.contentHeight + "px",
                          },
                        },
                        [
                          _c("studip-progress-indicator", {
                            attrs: {
                              description: _vm.$gettext(
                                "Vorgang wird bearbeitet..."
                              ),
                            },
                          }),
                        ],
                        1
                      ),
                ],
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }